import { createReducer, on } from '@ngrx/store';
import { addComponent, clearComponents, publishEvent, removeComponent, selectComponentById, setComponents, updateComponent } from './master-view.actions';
import { MasterViewState } from './master-view.state';

export const initialState: MasterViewState = {
  comps: [],
  compsevent: null
};

const _gridsterReducer = createReducer(
  initialState,
  on(setComponents, (state, { components }) => ({
    ...state,
    comps: components
  })),
  on(addComponent, (state, { item }) => ({
    ...state,
    comps: [...state.comps, item]
  })),
  on(removeComponent, (state, { id }) => ({
    ...state,
    comps: state.comps.filter(item => item.id !== id)
  })),
  on(updateComponent, (state, { item }) => ({
    ...state,
    comps: state.comps.map(i => i.id === item.id ? { ...i, ...item } : i)
  })),
  on(clearComponents, state => ({
    ...state,
    comps: []
  })),
  on(selectComponentById, (state, { id }) => {
    const selectedComponent = state.comps.find(comp => comp.id === id);
    return {
      ...state,
      selectedComponent
    };
  }),
  on(publishEvent, (state, { eventName, payload }) => ({
    ...state,
    compsevent: { eventName: eventName, payload: payload }
  }))
);

export function gridsterReducer(state, action) {
  return _gridsterReducer(state, action);
}
